import { Package, Ruler, ShoppingCart, Truck } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ICONS = [Package, Ruler, ShoppingCart, Truck];

export const OrderProcess = ({ compact = false }) => {
  const { t } = useLang();
  const circleSize = compact ? "w-14 h-14 sm:w-16 sm:h-16" : "w-24 h-24";
  const iconSize   = compact ? "w-5 h-5 sm:w-6 sm:h-6" : "w-8 h-8";
  const numSize    = compact ? "w-6 h-6 text-[10px] border-2" : "w-8 h-8 text-xs border-4";

  return (
    <section data-testid="order-process-section" className={`relative bg-[#EFD9B4]/40 ${compact ? "py-5 sm:py-6" : "py-8 sm:py-10"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center ${compact ? "mb-4" : "mb-6"}`}>
          {!compact && <div className="brand-ribbon mb-2">{t.order_process.ribbon}</div>}
          <h2 className={`font-display font-bold text-[#5A2D1D] ${compact ? "text-base sm:text-lg" : "text-xl sm:text-2xl lg:text-3xl"}`}>
            {t.order_process.h1} <span className="italic text-[#7A3B25]">{t.order_process.h2}</span>
          </h2>
        </div>

        <div className="relative">
          <div
            aria-hidden
            className="hidden lg:block absolute h-[2px] border-t-2 border-dashed border-[#5A2D1D]/40"
            style={{ top: compact ? "1.75rem" : "3rem", left: "12%", right: "12%" }}
          />
          <div className={`grid grid-cols-2 lg:grid-cols-4 relative ${compact ? "gap-4" : "gap-8"}`}>
            {t.steps.map((s, i) => {
              const Icon = ICONS[i];
              const num = String(i + 1).padStart(2, "0");
              return (
                <div key={num} data-testid={`step-${num}`} className="text-center">
                  <div className={`relative mx-auto ${circleSize} rounded-full bg-[#5A2D1D] text-[#F5E6CC] grid place-items-center shadow-lg ${compact ? "mb-2.5" : "mb-5"}`}>
                    <Icon className={iconSize} strokeWidth={1.6} />
                    <span className={`absolute -top-1.5 -right-1.5 bg-[#556B2F] text-[#F5E6CC] font-bold ${numSize} rounded-full grid place-items-center border-[#F5E6CC]`}>
                      {num}
                    </span>
                  </div>
                  <h3 className={`font-display font-bold text-[#5A2D1D] ${compact ? "text-xs sm:text-sm" : "text-lg sm:text-xl"}`}>{s.label}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
